"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STUDENT_RACE_OPTIONS = exports.STUDENT_ETHNICITY_OPTIONS = exports.PROVINCE_OPTIONS = exports.PARENTEDU_OPTIONS = exports.LANGUAGE_OPTIONS = exports.GRADE_OPTIONS = void 0;
// registration data
const STUDENT_ETHNICITY_OPTIONS = [{
  label: 'No, not of Hispanic, Latino, or Spanish Origin',
  value: '17',
  singleSelect: true
}, {
  label: 'Yes, Cuban',
  value: '14'
}, {
  label: 'Yes, Mexican',
  value: '5'
}, {
  label: 'Yes, Puerto Rican',
  value: '6'
}, {
  label: 'Yes, another Hispanic, Latino, or Spanish Origin',
  value: '7'
}];
exports.STUDENT_ETHNICITY_OPTIONS = STUDENT_ETHNICITY_OPTIONS;
const GRADE_OPTIONS = [{
  label: 'Not yet in 9th grade',
  value: 6
}, {
  label: '9th grade',
  value: 1
}, {
  label: '10th grade',
  value: 2
}, {
  label: '11th grade',
  value: 3
}, {
  label: '12th grade',
  value: 4
}, {
  label: 'No longer in high school',
  value: 5
}];
exports.GRADE_OPTIONS = GRADE_OPTIONS;
const LANGUAGE_OPTIONS = [{
  label: 'English',
  value: '1'
}, {
  label: 'English and another language about the same',
  value: '3'
}, {
  label: 'Another language',
  value: '4'
}, {
  label: 'I do not wish to respond',
  value: '0'
}];
exports.LANGUAGE_OPTIONS = LANGUAGE_OPTIONS;
const PARENTEDU_OPTIONS = [{
  label: 'Grade school',
  value: '1'
}, {
  label: 'Some high school',
  value: '2'
}, {
  label: 'High school diploma or equivalent',
  value: '3'
}, {
  label: 'Vocational or trade school',
  value: '4'
}, {
  label: 'Some college',
  value: '5'
}, {
  label: 'Associate or two-year degree',
  value: '6'
}, {
  label: "Bachelor's or four-year degree",
  value: '7'
}, {
  label: 'Some graduate or professional school',
  value: '8'
}, {
  label: 'Graduate or professional degree',
  value: '9'
}, {
  label: 'I do not wish to respond',
  value: '0'
}];
exports.PARENTEDU_OPTIONS = PARENTEDU_OPTIONS;
const PROVINCE_OPTIONS = {
  GB: [{
    label: 'England',
    value: 180
  }, {
    label: 'Guernsey',
    value: 668
  }, {
    label: 'Isle of Man',
    value: 277
  }, {
    label: 'Jersey',
    value: 670
  }, {
    label: 'Northern Ireland',
    value: 434
  }, {
    label: 'Scotland',
    value: 495
  }, {
    label: 'Wales',
    value: 610
  }],
  CA: [{
    label: 'Alberta',
    value: 650
  }, {
    label: 'British Columbia',
    value: 651
  }, {
    label: 'Manitoba',
    value: 653
  }, {
    label: 'New Brunswick',
    value: 654
  }, {
    label: 'Newfoundland',
    value: 643
  }, {
    label: 'Northwest Territories',
    value: 644
  }, {
    label: 'Nova Scotia',
    value: 645
  }, {
    label: 'Nunavut',
    value: 652
  }, {
    label: 'Ontario',
    value: 646
  }, {
    label: 'Prince Edward Island',
    value: 647
  }, {
    label: 'Quebec',
    value: 648
  }, {
    label: 'Saskatchewan',
    value: 649
  }, {
    label: 'Yukon Territory',
    value: 626
  }]
};
exports.PROVINCE_OPTIONS = PROVINCE_OPTIONS;
const STUDENT_RACE_OPTIONS = {
  asian: {
    label: 'Asian (including Indian sub-continent and Philippines origin)',
    value: '2'
  },
  black: {
    label: 'Black or African American (including Africa and Afro-Caribbean origin)',
    value: '3'
  },
  nativeAmerican: {
    label: 'Native American or Alaska Native',
    value: '1'
  },
  pacificIslander: {
    label: 'Native Hawaiian or other Pacific Islander',
    value: '8'
  },
  white: {
    label: 'White (including Middle Eastern origin)',
    value: '9'
  } // { label: 'I do not wish to respond', value: '0', singleSelect: true },

};
exports.STUDENT_RACE_OPTIONS = STUDENT_RACE_OPTIONS;